var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "liff-reservation-service"
  }, [_vm.fetching ? _c('div', {
    staticClass: "wizard-mode-layout__loading-overlay"
  }, [_c('div', {
    staticClass: "wizard-mode-layout__loading-spinner"
  }), _c('div', {
    staticClass: "wizard-mode-layout__loading-text"
  }, [_vm._v("載入中...")])]) : _c('div', [_vm.selectedBranch || _vm.selectedStaffForDisplay ? _c('h4', {
    staticClass: "text-center my-2"
  }, [_vm._v(_vm._s(_vm.selectedBranch.name) + " " + _vm._s(_vm.selectedStaffForDisplay))]) : _vm._e(), _vm.categories.length > 1 ? _c('div', [_c('div', {
    staticClass: "liff-reservation-service__category-list"
  }, _vm._l(_vm.categories, function (category) {
    return _c('div', {
      key: category.id,
      class: "liff-reservation-service__category".concat(_vm.openCategories[category.id] ? '__active' : ''),
      on: {
        "click": function click($event) {
          return _vm.scrollToService(category.id);
        }
      }
    }, [_vm._v(_vm._s(category.type))]);
  }), 0), _c('div', {
    staticClass: "liff-reservation-service__item mt-2",
    class: {
      'need-bottom': _vm.chosenServices.length > 0
    }
  }, _vm._l(_vm.categories, function (category) {
    return _c('b-card', {
      key: category.id,
      ref: category.id,
      refInFor: true,
      staticClass: "wizard-mode-layout__card",
      class: {
        'opened': _vm.openCategories[category.id]
      }
    }, [_c('div', {
      staticClass: "service-group-header",
      on: {
        "click": function click($event) {
          return _vm.toggle(category.id);
        }
      }
    }, [_c('div', [_vm._v(_vm._s(category.type))]), _c('BIconChevronDown', {
      staticClass: "service-group-header__expand-icon",
      attrs: {
        "height": 15
      }
    })], 1), _vm.openCategories[category.id] ? _c('div', {
      staticClass: "liff-reservation-service__content"
    }, _vm._l(category.items, function (service) {
      return _c('div', {
        key: service.id
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.chosenServices,
          expression: "chosenServices"
        }],
        staticClass: "liff-reservation-service__checkbox",
        attrs: {
          "type": "checkbox",
          "id": service.id
        },
        domProps: {
          "value": service.id,
          "checked": Array.isArray(_vm.chosenServices) ? _vm._i(_vm.chosenServices, service.id) > -1 : _vm.chosenServices
        },
        on: {
          "change": [function ($event) {
            var $$a = _vm.chosenServices,
              $$el = $event.target,
              $$c = $$el.checked ? true : false;
            if (Array.isArray($$a)) {
              var $$v = service.id,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.chosenServices = $$a.concat([$$v]));
              } else {
                $$i > -1 && (_vm.chosenServices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
              }
            } else {
              _vm.chosenServices = $$c;
            }
          }, _vm.handleServiceIsSelected]
        }
      }), _c('label', {
        staticClass: "liff-reservation-service__content-item",
        class: {
          'active': _vm.chosenServices.includes(service.id)
        },
        attrs: {
          "for": service.id
        }
      }, [service.image ? _c('img', {
        staticClass: "liff-reservation-service__content-item-img",
        attrs: {
          "src": service.image,
          "alt": ""
        }
      }) : _vm._e(), _c('div', {
        staticClass: "liff-reservation-service__content-item-info"
      }, [_c('div', {
        staticClass: "s-flex s-flex-col s-gap-2"
      }, [service.title ? _c('div', [_vm._v(_vm._s(service.title))]) : _vm._e(), service.description ? _c('div', {
        staticClass: "s-text-secondary s-text-sm"
      }, [_vm._v(_vm._s(service.description))]) : _vm._e()]), service.price ? _c('div', {
        staticClass: "s-text-primary"
      }, [_vm._v(_vm._s(service.price))]) : _vm._e()]), _vm.chosenServices.includes(service.id) ? _c('BIconCheckCircleFill', {
        staticClass: "s-text-primary liff-reservation-service__content-item-check",
        attrs: {
          "height": 20
        }
      }) : _vm._e()], 1)]);
    }), 0) : _vm._e()]);
  }), 1)]) : _c('div', [_c('div', {
    staticClass: "liff-reservation-service__item",
    class: {
      'need-bottom': _vm.chosenServices.length > 0
    }
  }, _vm._l(_vm.availableServices, function (service) {
    return _c('b-card', {
      key: service.id,
      staticClass: "wizard-mode-layout__card"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.chosenServices,
        expression: "chosenServices"
      }],
      staticClass: "liff-reservation-service__checkbox",
      attrs: {
        "type": "checkbox",
        "id": service.id
      },
      domProps: {
        "value": service.id,
        "checked": Array.isArray(_vm.chosenServices) ? _vm._i(_vm.chosenServices, service.id) > -1 : _vm.chosenServices
      },
      on: {
        "change": [function ($event) {
          var $$a = _vm.chosenServices,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = service.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.chosenServices = $$a.concat([$$v]));
            } else {
              $$i > -1 && (_vm.chosenServices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.chosenServices = $$c;
          }
        }, _vm.handleServiceIsSelected]
      }
    }), _c('label', {
      staticClass: "liff-reservation-service__content-item",
      class: {
        'active': _vm.chosenServices.includes(service.id)
      },
      attrs: {
        "for": service.id
      }
    }, [service.image ? _c('img', {
      staticClass: "liff-reservation-service__content-item-img",
      attrs: {
        "src": service.image,
        "alt": ""
      }
    }) : _vm._e(), _c('div', {
      staticClass: "liff-reservation-service__content-item-info"
    }, [_c('div', {
      staticClass: "s-flex s-flex-col s-gap-2"
    }, [service.title ? _c('div', [_vm._v(_vm._s(service.title))]) : _vm._e(), service.description ? _c('div', {
      staticClass: "s-text-secondary s-text-sm"
    }, [_vm._v(_vm._s(service.description))]) : _vm._e()]), service.price ? _c('div', {
      staticClass: "s-text-primary"
    }, [_vm._v(_vm._s(service.price))]) : _vm._e()]), _vm.chosenServices.includes(service.id) ? _c('BIconCheckCircleFill', {
      staticClass: "s-text-primary liff-reservation-service__content-item-check",
      attrs: {
        "height": 20
      }
    }) : _vm._e()], 1)]);
  }), 1)])]), _vm.availableServices.length === 0 && !_vm.fetching ? _c('div', [_vm._v(" 此分店無可選用的服務，請回上一頁重新選擇 ")]) : _vm._e(), _c('div', {
    staticClass: "wizard-mode-layout__footer-navigation"
  }, [_c('div', {
    staticClass: "s-flex s-justify-between s-items-center s-mb-3"
  }, [_c('div', {
    staticClass: "s-font-medium"
  }, [_vm._v("已選 " + _vm._s(_vm.chosenServices.length) + " 項："), _c('span', {
    staticClass: "s-text-primary"
  }, [_vm._v(_vm._s(_vm.chosenServicesText))])]), _c('div', {
    staticClass: "s-text-primary cursor-pointer s-font-medium s-flex-shrink-0",
    on: {
      "click": _vm.handleCleanServicesIsClicked
    }
  }, [_vm._v("重選")])]), _c('div', {
    staticClass: "wizard-mode-layout__footer-button-wrapper"
  }, [_vm.hasPreviousStep() ? _c('button', {
    staticClass: "s-btn s-liff-theme-btn-outline s-btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleNegativeButtonClicked
    }
  }, [_vm._v(" 上一步 ")]) : _vm._e(), _c('button', {
    staticClass: "s-btn s-liff-theme-btn s-btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.chosenServices.length == 0
    },
    on: {
      "click": _vm.handlePositiveButtonClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.textForProceedButton()) + " ")])])]), _c('Popup', {
    ref: "popup",
    attrs: {
      "title": "預約注意事項",
      "panelHeight": "auto"
    }
  }, [_c('div', {
    staticClass: "s-px-3 s-mb-6"
  }, [_c('ul', {
    staticClass: "s-list-decimal text-left",
    staticStyle: {
      "padding-left": "12px"
    }
  }, [_c('li', [_vm._v("預約時間為今日起30天內")]), _c('li', [_vm._v("如欲取消預約或更改時間可至確認郵件中點選取消連結或撥打專線由專人為您服務，使用上有任何問題歡迎撥打客服專線。"), _c('br'), _vm._v("客服電話： (02) 2222-2222")])])]), _c('div', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('button', {
    staticClass: "s-btn s-liff-theme-btn s-btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v(" 知道了 ")])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }